import type { BoardModelKind } from "./kind";

export function ensureBoardModelDebugFrame(
  host: HTMLElement,
  model: BoardModelKind,
  id: string,
): HTMLElement {
  const existing = host.querySelector<HTMLElement>(
    `[data-board-model="${model}"][data-board-id="${CSS.escape(id)}"]`,
  );
  if (existing !== null) {
    return existing;
  }
  const frame = document.createElement("div");
  frame.className = "board-model-debug-frame";
  if (model === "CharacterGroup") {
    frame.classList.add("board-model-debug-frame--character-group");
  }
  frame.dataset.boardDebugFrame = "";
  frame.dataset.boardModel = model;
  frame.dataset.boardId = id;
  host.appendChild(frame);
  return frame;
}

export function hideStaleBoardModelDebugFrames(
  host: HTMLElement,
  model: BoardModelKind,
  activeIds: ReadonlySet<string>,
): void {
  for (const frame of host.querySelectorAll<HTMLElement>(
    `[data-board-model="${model}"]`,
  )) {
    if (!activeIds.has(frame.dataset.boardId ?? "")) {
      frame.style.display = "none";
    }
  }
}
